import * as actionTypes from "../actionTypes";
import {store} from "../store";
import {encodeData, getUrlWithFiltersOrdini} from "../../shared/utils/axiosUtils";
import * as storageConstants from "../../shared/utils/constants/storage";
import {orderTypes} from "../../shared/utils/constants/orders";
import axios from "axios";
import OrderItemService from "../../api/orderItemService";
import fileSaver from 'file-saver'

let inCorsoCancelToken = axios.CancelToken.source();
let consegnatiCancelToken = axios.CancelToken.source();
let annullatiCancelToken = axios.CancelToken.source();
let suggestionCancelToken = axios.CancelToken.source();


export const fetchDataInCorso = (page, rowsPerPage) => {
    const inCorsoState = store.getState().ordiniDiSpedizioneReducer.inCorso;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const filter = store.getState().ordiniDiSpedizioneReducer.filter
    const query = getUrlWithFiltersOrdini(integrationId, `${inCorsoState.sorting}`, page, rowsPerPage, filter)

    return dispatch => {
        if (inCorsoState.loading) {
            inCorsoCancelToken.cancel();
            inCorsoCancelToken = axios.CancelToken.source();
        }
        dispatch({type: actionTypes.SET_LOADING_ORDINI, value: true, tab: "inCorso"});
        OrderItemService.fetchInCorso(query, inCorsoCancelToken.token).then((res) => {
            dispatch({
                type: actionTypes.FETCH_ORDINI_DATA_SUCCESS,
                tab: "inCorso",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count
            })
            dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "inCorso"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "inCorso"});
            }
        })
    }
}

export const fetchDataConsegnati = (page, rowsPerPage) => {
    const consegnatiState = store.getState().ordiniDiSpedizioneReducer.consegnati;
    const filter = store.getState().ordiniDiSpedizioneReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const query = getUrlWithFiltersOrdini(integrationId, `${consegnatiState.sorting}`, page, rowsPerPage, filter);

    return dispatch => {
        if (consegnatiState.loading) {
            consegnatiCancelToken.cancel();
            consegnatiCancelToken = axios.CancelToken.source();
        }
        dispatch({type: actionTypes.SET_LOADING_ORDINI, value: true, tab: "consegnati"});
        OrderItemService.fetchConsegnati(query, consegnatiCancelToken.token).then((res) => {
            dispatch({
                type: actionTypes.FETCH_ORDINI_DATA_SUCCESS,
                tab: "consegnati",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count
            });
            dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "consegnati"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "consegnati"});
            }
        })
    }

}

export const fetchDataAnnullati = (page, rowsPerPage) => {
    const annullatiState = store.getState().ordiniDiSpedizioneReducer.annullati;
    const filter = store.getState().ordiniDiSpedizioneReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const query = getUrlWithFiltersOrdini(integrationId, `${annullatiState.sorting}`, page, rowsPerPage, filter)

    return dispatch => {
        if (annullatiState.loading) {
            annullatiCancelToken.cancel();
            annullatiCancelToken = axios.CancelToken.source();
        }
        dispatch({type: actionTypes.SET_LOADING_ORDINI, value: true, tab: "annullati"});
        OrderItemService.fetchAnnullati(query, annullatiCancelToken.token).then((res) => {
            dispatch({
                type: actionTypes.FETCH_ORDINI_DATA_SUCCESS,
                tab: "annullati",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count
            });
            dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "annullati"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "annullati"});
            }
        })
    }
}

export const findOrderItemById = (rowId) => {
    let integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_ORDINI, value: true, tab: "details"});
        OrderItemService.fetchOrderDetails(rowId, integrationId).then((res) => {
            dispatch(setSelectedRow(res.data))
        }).catch((e) => {
            console.log(e);
        }).then(() => {
            dispatch({type: actionTypes.SET_LOADING_ORDINI, value: false, tab: "details"});
        });
    }
}

export const downloadOrdersCsv = (orderType, setIsFileDownloading) => {
    setIsFileDownloading(true);
    let state = store.getState().ordiniDiSpedizioneReducer;
    let integrationId = store.getState().authReducer.selectedCompany.integrationId
    const sorting = getSortingAccordingToOrderType(orderType);
    const query = getUrlWithFiltersOrdini(integrationId, `${sorting}`, 0, 0, state.filter)
    OrderItemService.downloadCsv(orderType, query).then((response) => {
        fileSaver.saveAs(response.data, `${orderType}_${new Date().toISOString()}.csv`)
    }).catch((e) => {
        console.log(e.response.data)
    }).finally(() => {
        setIsFileDownloading(false);
    })
}

export const fetchOrdiniFilterSuggestions = (searchText) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const suggestionsLoading = store.getState().ordiniDiSpedizioneReducer.ordiniSuggestion.loading;
    const query = `?integrationId=${integrationId}&orderNumber=${searchText}`
    return dispatch => {
        if (suggestionsLoading) {
            suggestionCancelToken.cancel();
            suggestionCancelToken = axios.CancelToken.source();
        }
        dispatch(setLoadingSuggestionOrdini(true))
        OrderItemService.fetchFilterSuggestions(encodeData(query), suggestionCancelToken.token).then((res) => {
            dispatch({
                type: actionTypes.SET_ORDINI_FILTER_SUGGESTION_DATA,
                suggestionList: res.data.data.map(d => {
                    return {
                        text: d.orderNumber
                    }
                })
            })
            dispatch(setLoadingSuggestionOrdini(false))
        }).catch((e) => {
            if (!axios.isCancel(e)) {
                dispatch(setLoadingSuggestionOrdini(false))
            }
        })
    }
}

export const changeFilterOrdini = (value, filterType) => {
    return {
        type: actionTypes.CHANGE_FILTER_ORDINI,
        value: value,
        filterType: filterType
    }
}

const setSelectedRow = (row) => {
    return {
        type: actionTypes.SET_SELECTED_TABLE_ROW,
        selectedRow: row
    }
}


export const setSelectedTab = (value) => {
    sessionStorage.setItem(storageConstants.ORDERS_TAB, value);
    return {
        type: actionTypes.SET_SELECTED_TAB,
        selectedTab: value
    }
}

export const setSortingOrdini = (value, tab) => {
    return {
        type: actionTypes.SET_SORTING_ORDINI,
        value: value,
        tab: tab
    }
}

const getSortingAccordingToOrderType = (orderType) => {
    let state = store.getState().ordiniDiSpedizioneReducer;
    switch (orderType) {
        case orderTypes.consegnati:
            return state.consegnati.sorting;
        case orderTypes.annullati:
            return state.annullati.sorting;
        case orderTypes.inCorso:
            return state.inCorso.sorting;
        default:
            return "";
    }
}

export const setLoadingSuggestionOrdini = (val) => {
    return {type: actionTypes.SET_ORDINI_SUGGESTION_LOADING, value: val}
}
